import { create } from "zustand";
import { persist } from "zustand/middleware";

type AuthStore = {
  isAuthenticated: boolean;
  Login_id: number;
  authenticate: () => void;
  signout: () => void;
};

export const useAuthStore = create(
  persist<AuthStore>(
    (set) => ({
      isAuthenticated: false,
      Login_id: 0,
      authenticate: () => set({ isAuthenticated: true }),
      signout: () => set({ isAuthenticated: false }),
    }),
    {
      name: "auth-storage", // unique name of the storage
      getStorage: () => sessionStorage, // specify the storage to use (localStorage)
    }
  )
);